// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"6efd2ed0","592":"f6d399a8","677":"1bfb9431","694":"ac3f6fc4","778":"cb3713ae"}[chunkId] + ".chunk.css";
};